import React from 'react'
import {Modal} from 'semantic-ui-react'
import style from './style.module.css'

const Dialog = ({children, ...rest}) => (
  <Modal size="small" {...rest}>
    {children}
  </Modal>
)

Dialog.Header = ({children}) => (
  <div className={style.header}>{children}</div>
)

Dialog.Content = ({children, ...rest}) => (
  <Modal.Content {...rest}>
    <Modal.Description>
      <div className={style.content}>{children}</div>
    </Modal.Description>
  </Modal.Content>
)

Dialog.Actions = ({children}) => (
  <div className={style.actions}>
    {children}
  </div>
)

export default Dialog